import { makeVar } from '@apollo/client';
/**
 * Reactive variable to store the current page type override from the URL/app state.
 * This allows ViewMeta to reflect the current page state without context plumbing.
 *
 * When set, this overrides the stored visualization type in ViewMeta.
 * When null, ViewMeta uses its stored currentViewVisualization.
 */
export const pageTypeVar = makeVar(null);